/**
 * Copyright (c) 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

var fbemitter = {
  EventEmitter: require('./lib/BaseEventEmitter')
};

module.exports = fbemitter;



/*****************
 ** WEBPACK FOOTER
 ** ./~/fbemitter/index.js
 ** module id = 77
 ** module chunks = 0
 **/